var moduleMap = {
	"./init": function() {
		return Promise.all([__webpack_require__.e(2750), __webpack_require__.e(4714), __webpack_require__.e(5131), __webpack_require__.e(9236)]).then(function() { return function() { return (__webpack_require__(19236)); }; });
	},
	"./routes": function() {
		return Promise.all([__webpack_require__.e(2750), __webpack_require__.e(275), __webpack_require__.e(4078), __webpack_require__.e(4714), __webpack_require__.e(6302)]).then(function() { return function() { return (__webpack_require__(46302)); }; });
	},
	"./Navigation": function() {
		return Promise.all([__webpack_require__.e(2750), __webpack_require__.e(4078), __webpack_require__.e(5131), __webpack_require__.e(2721)]).then(function() { return function() { return (__webpack_require__(52721)); }; });
	},
	"./PlanCard": function() {
		return Promise.all([__webpack_require__.e(2750), __webpack_require__.e(4078), __webpack_require__.e(4714), __webpack_require__.e(5131), __webpack_require__.e(870)]).then(function() { return function() { return (__webpack_require__(870)); }; });
	}
};
var get = function(module, getScope) {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(function() {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = function(shareScope, initScope) {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: function() { return get; },
	init: function() { return init; }
});